import React from 'react'
import Job from './Job'

const JobList = ({ jobs }) => {
  return (
    <div className="row">
      {jobs.map((job, index) => (
        <Job key={index} job={job} />
      ))}
    </div>
  )
}

export default JobList
